import { Action } from 'redux';
import { ContractConcept } from '../../../models/Entities/Contracts/ContractConcept';
import { ContractConceptState, ContractConceptUnloadState } from '../../states/ContractConceptState';


export default function ContractConceptCreateReducer(
  state: ContractConceptState | undefined,
  action: Action
): ContractConceptState {
  const currentState = state ?? ContractConceptUnloadState;
  const a: any = action;
  let CurrentConcept: ContractConcept | undefined;

  switch (a.type) {
    case 'CONTRACTCONCEPT_GET_BY_ID_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingOne: true,
        isLoadingOneSuccess: undefined,
        FailGettingOne: false,
      };

    case 'CONTRACTCONCEPT_GET_BY_ID_RECEIVE_ACTION': {
      const currentList = currentState.list || [];
      const filteredList = currentList.filter((item: ContractConcept) => item.id !== a.contractConcept.id);
      return {
        ...currentState,
        isLoadingOne: false,
        isLoadingOneSuccess: true,
        FailGettingOne: false,
        list: [...filteredList, a.contractConcept],
      };
    }

    case 'CONTRACTCONCEPT_GET_BY_ID_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingOne: false,
        isLoadingOneSuccess: false,
        FailGettingOne: true,
        error: a.error,
      };

    case 'CONTRACTCONCEPT_ADD_REQUEST_ACTION':
      return {
        ...currentState,
        isAddingNewOne: true,
        successAddingNewOne: undefined,
        failOnAddingNewOne: false,
      };
    
    case 'CONTRACTCONCEPT_ADD_RECEIVE_ACTION':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
      };
    
    case 'CONTRACTCONCEPT_ADD_FAIL_ACTION':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: a.error,
      };
    
    default:
      return currentState;
  }
}
